module.exports = __webpack_public_path__ + "static/media/desktopCharlieAddMobileIcon.b93fcb63.svg";